// messages.ts
import { defineMessages } from 'react-intl';

export const content = defineMessages({
  noPartners: {
    id: 'atossa.partnershipPage.noPartners',
    defaultMessage: 'No Partner Added',
  },
  partnershipSaveFailAlert: {
    id: 'atossa.partnershipPage.saveFail',
    defaultMessage: 'Failed to save',
  },
  partnershipSaveSuccessAlert: {
    id: 'atossa.partnershipPage.saveSuccess',
    defaultMessage: 'Successfully saved',
  },
  partnershipLoading: {
    id: 'atossa.partnershipPage.loading',
    defaultMessage: 'Loading',
  },
  secretKey: {
    id: 'atossa.partnershipPage.secretKey',
    defaultMessage: 'Secret Key',
  },
  pubKey: {
    id: 'atossa.partnershipPage.pubKey',
    defaultMessage: 'Public Key',
  },
  trafficMediumNumber: {
    id: 'atossa.partnershipPage.trafficMediumNumber',
    defaultMessage: 'Traffic Medium Number',
  },
  trafficSourceNumber: {
    id: 'atossa.partnershipPage.trafficSourceNumber',
    defaultMessage: 'Traffic Source Number',
  },
  accountId: {
    id: 'atossa.partnershipPage.accountId',
    defaultMessage: 'Account ID',
  },
});
